// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_45-2";
export var blackBorderOnHover = "_45-7";
export var cell = "_45-6";
export var cellContainer = "_45-3";
export var checked = "_45-8";
export var disabled = "_45-5";
export var featuredIconCellContainer = "_45-9";
export var featuredIconTextContainer = "_45-b";
export var featuredIconWrapper = "_45-a";
export var noBorder = "_45-c";
export var orangeSelectedRow = "_a2-3";
export var overflowableText = "_45-0";
export var overflowableTextContainer = "_45-1";
export var row = "_46-0";
export var rowCheckboxCell = "_45-4";
export var selectableTable = "_a2-2";